import { SetContextLink } from "@apollo/client/link/context";
import { type FencePresentation, fenceStore } from "@shuttlerock/utils";
import { OperationTypeNode } from "graphql";

export type FenceContext = {
  tokens: readonly FencePresentation[];
};

/**
 * The request half of the read-your-writes fence (the rywf pilot,
 * docs/state-distribution/rywf-fence-pilot/SCOPE.md, "FE BEHAVIOR slice"):
 * attaches the store's live write-tokens to every query's context as
 * `fence.tokens`. The store owns liveness (TTL/capacity/verifiability);
 * this is only the Apollo wiring, so it lives beside the other links that
 * make up the client.
 *
 * Deliberately header-shaped: when the F2 header lane lands, this link
 * writes the tokens into the request header instead of the context, and
 * the per-field `atLeast` adapter beside it is deleted — nothing else
 * moves. Until then the context is the seam the adapter transcribes from.
 */
export const fencePresentLink = new SetContextLink((prevContext, operation) => {
  if (operation.operationType !== OperationTypeNode.QUERY) {
    return {};
  }
  const tokens = fenceStore.presentations();
  if (tokens.length === 0) {
    return {};
  }
  const fence: FenceContext = { tokens };
  return { fence };
});
